module.exports = __webpack_public_path__ + "img/LogoPayline.2ac1eb27.png";